import { gql } from 'graphql.macro';
import { chatMessageFragment, messagesFragment } from 'apollo/fragments';

export const messagesTemplate = gql`
    query messages($orderId: MongoDbObjectId!) {
        messages(orderId: $orderId) {
            ...messagesFields
        }
    }
    ${messagesFragment}
`;

export const chatMessagesTemplate = gql`
    query chatMessages($orderId: MongoDbObjectId!) {
        chatMessages(orderId: $orderId) {
            ...chatMessage
        }
    }
    ${chatMessageFragment}
`;

export const translateOrderCommentsToEnglishTemplate = gql`
    query translateOrderCommentsToEnglish($orderId: MongoDbObjectId!) {
        translateOrderCommentsToEnglish(orderId: $orderId)
    }
`;
